import { useQueryClient } from '@tanstack/react-query';
import React from 'react';
import { useNavigate } from 'react-router';
import { Button } from 'reactstrap';
import { useDict } from '../../../contexts/LanguageContext';
import ROUTE_NAME from '../../../routes/RouteName';

const LogOutForm = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const dict = useDict();

    const handleSubmitLogout = () => {
        queryClient.clear();
        sessionStorage.clear();
        navigate(ROUTE_NAME.HOME);
    };

    const cancelLogout = () => {
        navigate(-1);
    }

    return (
        <form className="form" onSubmit={handleSubmitLogout}>
            <div className="account__btns">
                <Button
                    color="primary"
                    className="btn account__btn btn-logout rounded"
                    onClick={cancelLogout}
                >
                    {dict.cancel}
                </Button>
                &nbsp;
                <Button
                    color="primary"
                    outline
                    className="btn btn-outline-primary account__btn btn-logout rounded"
                    type="submit"
                    data-cy="logout__confirmBtn"
                >
                    {dict.proceed}
                </Button>
            </div>
        </form>
    );
};

export default LogOutForm;
